import { useState } from "react";
import { CarouselSubcategory, NewCard, NewCardSpider } from "../../components";
import { Button, Flex, SimpleGrid } from "@mantine/core";
import BigHeader from "../../Layout/BigHeader";
import { useInfiniteProducts } from "../../hooks/useProducts";
import { useTranslation } from "react-i18next";
import { client_selected } from "../../client";
import { useParams } from "react-router-dom";
import { subcategories } from "../../utils/SubCategorys";
import { whitelabel_id } from "../../api";
import { useAuth } from "../../context/auth";
import { useMyPlans } from "../../hooks";
import { EPlanStatus } from "../../interfaces/MyPlans";

const Marketplace = () => {
  const { t } = useTranslation();
  const [partner, setPartner] = useState<number>(0);
  const { isAuthenticated } = useAuth();
  const isGenial = client_selected.name === "Genial";
  const { subcategory = "" } = useParams<{ subcategory?: string }>();

  const { data, fetchNextPage, hasNextPage, isFetchingNextPage } =
    useInfiniteProducts({
      page: 1,
      subcategory: subcategory,
      white_label_id: whitelabel_id,
    });

  const { data: dataMyPlans, isFetched: isFetchedMyPlans } = useMyPlans({
    enabled: isAuthenticated,
    status: "",
  });
  const selectedTitleIsGenial = isGenial
    ? "global.routes_names.copytrading"
    : "marketplace.title";

  const selectedTitle =
    subcategories.find(
      (item) => item.value !== "" && item.value === subcategory
    )?.name ?? selectedTitleIsGenial;

  return (
    <BigHeader title={t(selectedTitle)} hasOverlay={true}>
      <CarouselSubcategory />

      <Flex align="center" direction={"column"} mb={108}>
        <Flex w="100%" wrap="wrap" gap="16px">
          <SimpleGrid
            spacing={16}
            breakpoints={[
              { minWidth: 700, cols: 2 },
              { minWidth: 1200, cols: 3 },
              { minWidth: 1600, cols: 4 },
            ]}
            w={"100%"}
          >
            {data?.pages.map((page) =>
              page.data.map((item, index: number) => {
                const isMyPlan = dataMyPlans?.dates.some((date) =>
                  date.user_plans.some(
                    (plan) =>
                      plan.product.id === Number(item.id) &&
                      (plan.status === EPlanStatus.Approved ||
                        plan.status === EPlanStatus.InProcessing ||
                        plan.status === EPlanStatus.CancelRequested)
                  )
                );
                return isGenial ? (
                  <NewCard
                    key={index}
                    item={item}
                    preSlug="/marketplace/detalhes/"
                    purchase={isMyPlan}
                  />
                ) : (
                  <NewCardSpider
                    key={index}
                    item={item}
                    preSlug="/marketplace/detalhes/"
                    purchase={isMyPlan}
                  />
                );
              })
            )}
          </SimpleGrid>
        </Flex>
        {!!hasNextPage && (
          <Button
            w={254}
            variant="primaryTransparent"
            mt={48}
            onClick={() => fetchNextPage()}
            loading={isFetchingNextPage}
            disabled={!hasNextPage}
          >
            {isFetchingNextPage
              ? t("global.button.loading")
              : t("global.button.loading_more")}
          </Button>
        )}
      </Flex>
    </BigHeader>
  );
};

export default Marketplace;
